import {isDealUnavailable} from "@irati/deals/helpers/deals/isDealUnavailable"
import DealSavingsTypes from "@irati/deals/types/enums/DealSavingsType"
import {Deal, DealType} from "@irati/types"
import mainTheme from "@irati/ui/src/global/theme"
import {Hr} from "@irati/ui/src/Layout"

import isBoostedPerk from "@irati/deals/helpers/deals/isBoostedPerk"
import EarnPointsBadge from "../EarnPointsBadge"
import Flex from "@irati/ui/src/Flex"
import {IconTypes} from "@irati/ui/src/Icon"
import FormattedMessage from "@irati/utils/lang"
import React from "react"
import authentication from "@irati/auth"
import DealLabel from "./DealLabel"
import DealPromoSavingInfo from "./DealPromoSavingInfo"
import {Container, StyledLabel} from "./style"

export type SavingProps = {
  deal: Required<Deal>
  allowEarnPointsModal?: boolean
}

const {FREE, SPECIAL_RATES} = DealSavingsTypes

export const DealPromoInfo = ({deal}: SavingProps) => {
  const {userSavings} = deal.savings
  const savingType = userSavings?.type as DealSavingsTypes

  const isFreeOrSpecialRate = savingType && [SPECIAL_RATES, FREE].includes(savingType)
  const hasFpWallet = authentication.apps("wallet.treatTokens")
  const withEarnPoints = !isFreeOrSpecialRate && hasFpWallet && deal.earnPoints
  const isCompanyBenefit = deal.type === DealType.Company

  const renderContent = () => {
    if (isFreeOrSpecialRate || isCompanyBenefit) {
      let id = savingType === DealSavingsTypes.FREE ? "perks.saving.free" : "perks.components.saving.specialRates"
      if (isCompanyBenefit) {
        id = "perks.components.saving.companyBenefit"
      }

      return <DealLabel intlId={id} large paddingLeft={mainTheme.spacing.half} paddingRight={mainTheme.spacing.half} />
    }

    if (isDealUnavailable(deal)) {
      return (
        <DealLabel
          small
          color={mainTheme.colors.utility.contrast}
          iconColor={mainTheme.colors.utility.warning}
          icon={IconTypes.circleInformation}
          intlId="perks.components.dealBody.unavailableDeal.header"
        />
      )
    }

    const isBoosted = isBoostedPerk(deal)
    return <DealPromoSavingInfo deal={deal} isBoosted={isBoosted} />
  }

  return (
    <>
      <Hr marginTop="0px" marginBottom="0px" />
      <Flex padding={mainTheme.spacing.oneAndHalf} gap={mainTheme.spacing.half} alignItems="center">
        {withEarnPoints && !isDealUnavailable(deal) && (
          <>
            <Container>
              <EarnPointsBadge deal={deal} newDesign />
            </Container>
            <StyledLabel small bold>
              <FormattedMessage id="platform.earnPoints.component.or" />
            </StyledLabel>
          </>
        )}
        <Container>{renderContent()}</Container>
      </Flex>
    </>
  )
}

export default DealPromoInfo
